// opervex-frontend/src/pages/Reports/ServiceOrder.js

import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import DynamicReport from "../../components/DynamicReport";
import useOpervex from "../../hooks/useOpervex";

const ServiceOrder = () => {
  const [schema, setSchema] = useState(null);
  const OpervexAPI = useOpervex();

  useEffect(() => {
    const loadSchema = async () => {
      const result = await OpervexAPI.Report.ServiceOrder.schema();
      setSchema(result);
    };

    loadSchema();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!schema)
    return (
      <Container fluid className="text-center mt-5">
        <span>Carregando relatório...</span>
      </Container>
    );

  return (
    <>
      <h1 className="fw-light text-center">Relatório de Ordem de Serviço</h1>

      <DynamicReport
        reportName={"reportServiceOrder"}
        urlData={"/Report/ServiceOrder"}
        schema={schema}
        links={[
          { key: "id", link: "/ServiceManagement/ServiceOrder/:id", newPage: true },
          {
            key: "reversal",
            link: "/ServiceManagement/ServiceOrder/:id",
            newPage: true,
          },
          { key: "gmId", link: "/MaterialManagement/GoodsMovement/:id", newPage: true },
        ]}
      />
    </>
  );
};

export default ServiceOrder;
